import React, { FC, useState } from "react";
import { Spin, Tabs as AntdTabs } from "antd";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import TradingVolumesTab from "./TradingVolumesTab";

const { TabPane } = AntdTabs;

const TradingVolumes: FC = () => {
  const [period, setPeriod] = useState("0");
  const { fetchedData: data, loading } = useHttpGet<{
    result: any;
  }>(`${APIRoutes.CRYPTO_MARKETS_TRADING_VOLUMES}/${period}`, {
    dependencies: [period],
    defaultValue: {
      result: {
        list: [],
      },
    },
  });

  const handleTabChanges = (period: any) => {
    setPeriod(period);
  };

  return (
    <Spin spinning={loading}>
      <AntdTabs defaultActiveKey={period} onChange={handleTabChanges}>
        <TabPane tab="Today" key="0">
          <TradingVolumesTab data={data?.result} />
        </TabPane>
        <TabPane tab="Week ago" key="1">
          <TradingVolumesTab data={data?.result} />
        </TabPane>
        <TabPane tab="1 Month ago" key="2">
          <TradingVolumesTab data={data?.result} />
        </TabPane>
        <TabPane tab="2 Month ago" key="3">
          <TradingVolumesTab data={data?.result} />
        </TabPane>
        <TabPane tab="3 Month ago" key="4">
          <TradingVolumesTab data={data?.result} />
        </TabPane>
      </AntdTabs>
    </Spin>
  );
};

export default TradingVolumes;
